import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
// import mobilePreview from '@/views/template/frontPageManage/configureManage/mobilePreview/components';
import mobilePreview from '@/views/template/frontPageManage/configureManage/mobilePreview';
import { INITAL } from '@/views/template/frontPageManage/configureManage/utils';
export default {
  components: {
    mobilePreview
  },
  data() {
    return {
      dialogVisible: false,
      arr: [],
      title: '',
      themeColor: '',
      INITAL,
      pageType: '',
      premiumShow: false,
      configureObj: {},
      pageDescriptionConfig: {},
      pagePopUp: false,
      pagePopUpConfig: {},
      pageModalShow: false,
      buttonModalShow: false,
      buttonPopUpConfig: {},
      buttonModalIndex: -1
    };
  },
  methods: {
    onClickPremium(index) {
      if (index === 0) {
        this.onOpenButtonModal(index, '');
      } else {
        this.premiumShow = false;
      }
    },
    // 打开按钮弹窗
    onOpenButtonModal(index, key, isPremium) {
      var _this$arr$style;
      this.buttonModalIndex = index;
      let item = (_this$arr$style = this.arr[this.arr.length - 1].style) === null || _this$arr$style === void 0 ? void 0 : _this$arr$style.buttonInfo[index];
      if (item.buttonPopUp) {
        this.buttonPopUpConfig = item.buttonPopUpConfig;
        if (key != 'change') {
          this.buttonModalShow = true;
        }
      } else {
        this.buttonModalIndex = -1;
        this.buttonPopUpConfig = {};
      }
    },
    init(val) {
      const controlsGroupConfig = JSON.parse(val.controlsGroupConfig);
      let arr = [];
      this.pageDescription = controlsGroupConfig.pageDescription;
      this.pageDescriptionConfig = controlsGroupConfig.pageDescriptionConfig;
      this.pagePopUp = controlsGroupConfig.pagePopUp;
      this.pagePopUpConfig = controlsGroupConfig.pagePopUpConfig;
      if (this.pagePopUp) {
        this.pageModalShow = true;
      } else {
        this.pageModalShow = false;
      }
      controlsGroupConfig.controlsConfig.map(item => {
        let obj = {
          controlsId: item.controlsId,
          controlsMark: item.controlsMark,
          isClick: false,
          style: item.controlsObject
        };
        arr.push(obj);
      });
      this.arr = arr;
      this.dialogVisible = true;
    }
  }
};